import Vue from 'vue';
import { init } from '@sentry/browser';
import { Vue as SentryVue } from '@sentry/integrations';
var dsn = window.Config.sentry_dsn;
if (dsn) {
    init({
        dsn: dsn,
        integrations: [new SentryVue({ Vue: Vue, attachProps: true, logErrors: true })],
    });
}
